import { useCurrentPageAccess } from "@/app/router";
import { Breadcrumbs } from "@/shared/components/layout/Breadcrumbs";
import { PageHeader } from "@/shared/components/layout/PageHeader";
import { Card } from "@/shared/components/ui/card";
import { Skeleton } from "@/shared/components/ui/skeleton";
import { AlertCircle } from "lucide-react";
import { BoolConfigRow, ConfigGroup, IntConfigRow } from "../components/ConfigRows";
import { usePrismConfig } from "../hooks/usePrismConfig";
export function PreferencesCollectionSettingsPage() {
  const { groups, isLoading, isError, changeBool, saveInt } = usePrismConfig();
  const { canWriteCurrentPage } = useCurrentPageAccess();

  return (
    <div className="space-y-6">
      <Breadcrumbs />
      <PageHeader
        title="프리즘 수집 설정"
        description="프리즘 주요 설정들을 관리합니다."
      />

      {isLoading && (
        <Card className="p-6">
          <div className="space-y-4">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </div>
        </Card>
      )}

      {isError && (
        <Card className="border border-rose-200 bg-rose-50 p-6">
          <div className="flex items-center gap-3">
            <AlertCircle className="h-5 w-5 text-rose-600" />
            <div>
              <div className="font-medium text-rose-900">데이터를 불러올 수 없습니다</div>
              <div className="mt-1 text-sm text-rose-800">
                설정을 불러오는 중 오류가 발생했습니다. 페이지를 새로고침해주세요.
              </div>
            </div>
          </div>
        </Card>
      )}

      {!isLoading && !isError && groups.map((g) => (
        <ConfigGroup key={g.title} title={g.title}>
          {g.items.map((it) => {
            if (it.type === "bool") {
              return (
                <BoolConfigRow
                  key={it.name}
                  item={it}
                  onChange={(v) => changeBool(it.name, v)}
                  canWrite={canWriteCurrentPage}
                />
              );
            }

            return (
              <IntConfigRow
                key={it.name}
                item={it}
                onSave={(n) => saveInt(it.name, n)}
                canWrite={canWriteCurrentPage}
              />
            );
          })}
        </ConfigGroup>
      ))}
    </div>
  );
}
